// extracted by mini-css-extract-plugin
export default {"container":"SocialCommentsList_container_LqblE","button":"SocialCommentsList_button_urMzl","arrow":"SocialCommentsList_arrow_iiBZQ"};